var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import Notifications from "../Notifications";
import Cookiepopup from "./Cookiepopup";
import { TranslateForm, t } from "../I18N";
import { Icon } from "../UI";

import { socket } from "../socket";
import { NotificationsContainer } from "../V2/Components/UI";
import { settingsAtom } from "../V2/atoms/settingsAtom";
import Confirm from "./Confirm";
import { Menu } from "./Menu";
import { AppMainContext } from "./AppMainContext";
import SiteName from "./SiteName";
import GoogleAnalytics from "./GoogleAnalytics";
import Matomo from "./Matomo";
import 'bootstrap/dist/css/bootstrap.css';
import 'react-widgets/lib/scss/react-widgets.scss';
import 'nprogress/nprogress.css';
import 'flag-icon-css/sass/flag-icons.scss';
import "./scss/styles.scss";
import "./styles/globals.css";
import 'flowbite';

const App = ({ customParams }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState({});
  const setSettings = useSetRecoilState(settingsAtom);

  const location = useLocation();
  const params = useParams();
  const sharedId = params.sharedId || (customParams === null || customParams === void 0 ? void 0 : customParams.sharedId);
  const shouldAddAppClassName =
  ['/', `/${params.lang}/`].includes(location.pathname) ||
  location.pathname.match(/\/page\/.*\/.*/g) ||
  location.pathname.match(/\/entity\/.*/g);

  const toggleMobileMenu = (visible) => {
    setShowMenu(visible);
  };

  const confirm = (options) => {
    setConfirmOptions(options);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const appContext = useMemo(() => ({ confirm }));

  let MenuButtonIcon = 'bars';
  let navClass = 'menuNav';

  if (showMenu) {
    MenuButtonIcon = 'times';
    navClass += ' is-active';
  }

  const appClassName = shouldAddAppClassName && sharedId ? `pageId_${sharedId}` : '';

  socket.on('updateSettings', (settings) => {
    setSettings(settings);
  });

  return /*#__PURE__*/(
    _jsx("div", { id: "app", className: appClassName }, void 0, /*#__PURE__*/
    _jsx(Notifications, {}), /*#__PURE__*/
    _jsx(Cookiepopup, {}), /*#__PURE__*/
    _jsx("div", { className: "content" }, void 0, /*#__PURE__*/
    _jsx("nav", {}, void 0, /*#__PURE__*/
    _jsx("h1", {}, void 0, /*#__PURE__*/
    _jsx(SiteName, {})
    )
    ), /*#__PURE__*/
    _jsx("header", {}, void 0, /*#__PURE__*/
    _jsx("button", {
      className: "menu-button",
      onClick: () => toggleMobileMenu(MenuButtonIcon === 'bars'),
      type: "button",
      "aria-label": t('System', 'Menu', null, false) }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: MenuButtonIcon })
    ), /*#__PURE__*/
    _jsx("h1", { className: "logotype" }, void 0, /*#__PURE__*/
    _jsx(SiteName, {})
    ), /*#__PURE__*/
    _jsx(Menu, { location: location, toggleMobileMenu: toggleMobileMenu, className: navClass }), /*#__PURE__*/
    _jsx("div", { className: "nprogress-container" })
    ), /*#__PURE__*/
    _jsx("main", { className: "app-content container-fluid" }, void 0, /*#__PURE__*/
    _jsx(AppMainContext.Provider, { value: appContext }, void 0, /*#__PURE__*/
    React.createElement(Confirm, confirmOptions), /*#__PURE__*/
    _jsx(TranslateForm, {}), /*#__PURE__*/
    _jsx(Outlet, {}), /*#__PURE__*/
    _jsx(GoogleAnalytics, {}), /*#__PURE__*/
    _jsx(Matomo, {})
    )
    )
    ), /*#__PURE__*/
    _jsx(NotificationsContainer, {})
    ));

};







export { App };